import { axiosService } from 'service'
import { salesReceiptEndpoints } from 'service/sources/sales/receipt'

const receiptList = (options) => {
  return axiosService.get(salesReceiptEndpoints.LIST + options)
}

const create = (values) => {
  return axiosService.post(salesReceiptEndpoints.CREATE, values)
}

const infoOneReceipt = (id, empresa) => {
  return axiosService.get(salesReceiptEndpoints.ONE_RECEIPT + id + '/' + empresa)
}

const deleteReceiptItem = (id, empresa, recibo) => {
  return axiosService.del(
    salesReceiptEndpoints.DELETE_RECEIPT_ITEM + id + '/' + empresa + '/' + recibo
  )
}

const addReceiptItem = (values) => {
  return axiosService.post(salesReceiptEndpoints.ADD_RECEIPT_ITEM, values)
}

const editReceiptItem = (body) => {
  return axiosService.put(salesReceiptEndpoints.EDIT_RECEIPT_ITEM, body)
}

const deleteReceipt = (id, empresa) => {
  return axiosService.del(salesReceiptEndpoints.DELETE_RECEIPT + id + '/' + empresa)
}

const exportReceipt = (body) => {
  return axiosService.post(salesReceiptEndpoints.EXPORT_RECEIPT, body)
}

const edit = (id, empresa, body) => {
  return axiosService.put(salesReceiptEndpoints.EDIT_RECEIPT + id + '/' + empresa, body)
}

const before = () => {
  return axiosService.get(salesReceiptEndpoints.BEFORE)
}

const generateReceipt = (id, empresa) => {
  return axiosService.post(salesReceiptEndpoints.GENERATE_RECEIPT + id + '/' + empresa)
}

export const salesReceipt = {
  receiptList,
  create,
  infoOneReceipt,
  deleteReceiptItem,
  addReceiptItem,
  editReceiptItem,
  deleteReceipt,
  exportReceipt,
  edit,
  before,
  generateReceipt,
}
